(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product"]) return;
  try {
    
  if (!customElements.get('product-media-nav')) {
    class ProductMediaNav extends HTMLElement {
      connectedCallback() {
        this.gallery = this.closest('product-images');
        this.scroller = this.gallery?.querySelector('[data-product-media-list]');
        this.slides = Array.from(this.scroller?.querySelectorAll('[data-slide]') || []);
        this.current = this.querySelector('[data-media-current]');
        this.previous = this.querySelector('[data-media-previous]');
        this.next = this.querySelector('[data-media-next]');
        this.label = this.dataset.label || '';
        this.index = 0;

        if (!this.gallery || !this.scroller || this.slides.length < 2) return;

        this.handlePrevious = () => this.goTo(this.index - 1);
        this.handleNext = () => this.goTo(this.index + 1);
        this.handleScroll = () => {
          if (this.frame) cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.updateFromScroll());
        };

        this.previous.addEventListener('click', this.handlePrevious);
        this.next.addEventListener('click', this.handleNext);
        this.scroller.addEventListener('scroll', this.handleScroll, {passive: true});

        this.activeMediaObserver = new MutationObserver(() => this.updateFromActiveMedia());
        this.activeMediaObserver.observe(this.gallery, {
          attributes: true,
          attributeFilter: ['data-active-media']
        });

        requestAnimationFrame(() => this.updateFromScroll());
      }

      disconnectedCallback() {
        this.previous?.removeEventListener('click', this.handlePrevious);
        this.next?.removeEventListener('click', this.handleNext);
        this.scroller?.removeEventListener('scroll', this.handleScroll);
        this.activeMediaObserver?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
      }

      updateFromActiveMedia() {
        const activeMedia = this.gallery.getAttribute('data-active-media');
        const index = this.slides.findIndex((slide) => slide.dataset.mediaId === activeMedia);
        if (index >= 0) this.setIndex(index);
      }

      updateFromScroll() {
        const maxScroll = this.scroller.scrollWidth - this.scroller.clientWidth;
        if (this.scroller.scrollLeft <= 2) {
          this.setIndex(0);
          return;
        }

        if (maxScroll - this.scroller.scrollLeft <= 2) {
          this.setIndex(this.slides.length - 1);
          return;
        }

        const scrollerLeft = this.scroller.getBoundingClientRect().left;
        let closestIndex = 0;
        let closestDistance = Number.POSITIVE_INFINITY;

        this.slides.forEach((slide, index) => {
          const distance = Math.abs(slide.getBoundingClientRect().left - scrollerLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        this.setIndex(closestIndex);
      }

      goTo(index) {
        const nextIndex = Math.max(0, Math.min(index, this.slides.length - 1));
        const slide = this.slides[nextIndex];
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.gallery.dispatchEvent(new CustomEvent('theme:media:select', {
          detail: {id: slide.dataset.mediaId, focus: true}
        }));

        slide.scrollIntoView({
          behavior: reduceMotion ? 'auto' : 'smooth',
          block: 'nearest',
          inline: 'start'
        });

        this.setIndex(nextIndex);
      }

      setIndex(index) {
        this.index = index;
        this.current.textContent = index + 1;
        this.previous.disabled = index === 0;
        this.next.disabled = index === this.slides.length - 1;
        this.querySelector('[data-media-count]').setAttribute(
          'aria-label',
          `${this.label} ${index + 1} / ${this.slides.length}`
        );
      }
    }

    customElements.define('product-media-nav', ProductMediaNav);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-bay-area-family-events"] && !Shopify.designMode) return;
  try {
    
  const initializeBayAreaEvents = async (root) => {
    if (root.dataset.eventsReady === 'true') return;
    root.dataset.eventsReady = 'true';

    const list = root.querySelector('[data-event-list]');
    const buttons = Array.from(root.querySelectorAll('[data-event-filter-group]'));
    const emptyState = root.querySelector('[data-event-empty]');
    const count = root.querySelector('[data-event-count]');
    const countLabel = root.querySelector('[data-event-count-label]');
    const pagination = root.querySelector('[data-event-pagination]');
    const loadingStatus = root.querySelector('[data-event-loading]');
    const showMoreButton = root.querySelector('[data-event-more]');
    const groupContext = root.querySelector('[data-event-group-context]');

    if (!list || buttons.length === 0 || !emptyState || !count || !countLabel) return;

    const totalPages = Number.parseInt(list.dataset.eventTotalPages, 10) || 1;
    const currentPage = Number.parseInt(list.dataset.eventCurrentPage, 10) || 1;
    const paginationLink = pagination?.querySelector('a[href]');
    const paginationUrl = paginationLink
      ? new URL(paginationLink.getAttribute('href'), window.location.origin)
      : null;
    const pageParam = paginationUrl
      ? Array.from(paginationUrl.searchParams.keys()).find((key) => key.startsWith('page')) || 'page'
      : 'page';
    let allPagesLoaded = totalPages === 1;
    const now = Date.now();
    const upcomingCards = (candidateCards) => candidateCards.filter((card) => {
      const end = Date.parse(card.dataset.eventEnd);
      if (Number.isFinite(end) && end < now) {
        card.remove();
        return false;
      }
      return true;
    });
    let cards = upcomingCards(Array.from(list.querySelectorAll('[data-event-card]')));
    const defaultVisibleLimit = 60;
    const storytimeVisibleLimit = Number.parseInt(root.dataset.storytimeInitialDates, 10) || 14;
    const defaultShowMoreText = showMoreButton?.textContent.trim() || '';
    const expandedStorytimeDates = new Set();
    let visibleLimit = defaultVisibleLimit;

    const groups = ['region', 'activity', 'schedule', 'host'];
    const queryParameters = {
      region: 'region',
      activity: 'activity',
      schedule: 'schedule',
      host: 'host'
    };
    const cardProperties = {
      region: 'eventRegion',
      activity: 'eventActivity',
      schedule: 'eventSchedule',
      host: 'eventHost'
    };
    const defaultValues = {
      region: 'all',
      activity: 'all',
      schedule: 'all',
      host: 'all'
    };
    const availableValues = Object.fromEntries(groups.map((group) => [
      group,
      new Set(buttons
        .filter((button) => button.dataset.eventFilterGroup === group)
        .map((button) => button.dataset.eventFilterValue))
    ]));
    const initialUrl = new URL(window.location.href);
    const selected = Object.fromEntries(groups.map((group) => {
      const requested = initialUrl.searchParams.get(queryParameters[group]);
      const fallback = availableValues[group].has(defaultValues[group]) ? defaultValues[group] : 'all';
      const value = requested && availableValues[group].has(requested) ? requested : fallback;
      return [group, value];
    }));
    visibleLimit = selected.activity === 'storytime-or-drop-in' ? storytimeVisibleLimit : defaultVisibleLimit;

    const cardMatchesGroup = (card, group, value) => {
      if (value === 'all') return true;
      if (group === 'activity' && value === 'events-and-classes') {
        return ['special-event', 'class-or-workshop'].includes(card.dataset.eventActivity);
      }
      return card.dataset[cardProperties[group]] === value;
    };

    const cardMatches = (card, filters) => groups.every((group) => {
      const value = filters[group];
      return cardMatchesGroup(card, group, value);
    });

    const sortCards = () => {
      cards.sort((first, second) => Date.parse(first.dataset.eventStart) - Date.parse(second.dataset.eventStart));
    };

    const createStorytimeRow = (card) => {
      const row = document.createElement('li');
      const sourceTime = card.querySelector('.bay-event__meta time');
      const sourceTitle = card.querySelector('.bay-event__body h3');
      const sourcePlace = card.querySelector('.bay-event__place');
      const sourceLink = card.querySelector('.bay-event__link');
      const details = document.createElement('div');
      const title = document.createElement('h4');

      row.className = 'bay-storytime-day__row';
      details.className = 'bay-storytime-day__details';
      title.textContent = sourceTitle?.textContent.trim() || '';

      if (sourceTime) {
        const time = sourceTime.cloneNode(true);
        time.classList.add('bay-storytime-day__time');
        row.append(time);
      } else {
        row.classList.add('bay-storytime-day__row--without-time');
      }

      details.append(title);
      if (sourcePlace) {
        const place = sourcePlace.cloneNode(true);
        place.classList.add('bay-storytime-day__place');
        details.append(place);
      }
      row.append(details);

      if (sourceLink) row.append(sourceLink.cloneNode(true));
      return row;
    };

    const createStorytimeList = (storytimeCards) => {
      const eventList = document.createElement('ul');
      eventList.className = 'bay-storytime-day__list';
      storytimeCards.forEach((card) => eventList.append(createStorytimeRow(card)));
      return eventList;
    };

    const createStorytimeGroup = (descriptor) => {
      const firstCard = descriptor.cards[0];
      const weekday = firstCard.querySelector('.bay-event__weekday')?.textContent.trim() || '';
      const dateLabel = firstCard.querySelector('.bay-event__date-label')?.textContent.trim() || '';
      const locationNames = new Set(descriptor.cards
        .map((card) => card.querySelector('.bay-event__place')?.textContent.replace(/\s+/g, ' ').trim())
        .filter(Boolean));
      const section = document.createElement('section');
      const date = document.createElement('div');
      const time = document.createElement('time');
      const weekdayLabel = document.createElement('span');
      const fullDateLabel = document.createElement('strong');
      const body = document.createElement('div');
      const eyebrow = document.createElement('p');
      const heading = document.createElement('h3');
      const overview = document.createElement('p');
      const headingId = `${root.id}-StorytimeDay-${descriptor.dateKey.replace(/[^a-z0-9-]/gi, '')}`;
      const groupLabel = descriptor.cards.length === 1
        ? root.dataset.storytimeGroupSingular
        : root.dataset.storytimeGroupPlural;
      const locationLabel = locationNames.size === 1
        ? root.dataset.storytimeLocationSingular
        : root.dataset.storytimeLocationPlural;

      section.className = 'bay-storytime-day';
      section.dataset.storytimeDayGroup = descriptor.dateKey;
      section.setAttribute('aria-labelledby', headingId);
      date.className = 'bay-storytime-day__date';
      body.className = 'bay-storytime-day__body';
      weekdayLabel.className = 'bay-storytime-day__weekday';
      fullDateLabel.className = 'bay-storytime-day__date-label';
      eyebrow.className = 'bay-storytime-day__eyebrow';
      heading.id = headingId;
      overview.className = 'bay-storytime-day__overview';

      time.dateTime = descriptor.dateKey;
      weekdayLabel.textContent = weekday;
      fullDateLabel.textContent = dateLabel;
      time.append(weekdayLabel, fullDateLabel);
      date.append(time);

      eyebrow.textContent = root.dataset.storytimeGroupLabel;
      heading.textContent = `${descriptor.cards.length} ${groupLabel}`;
      if (locationNames.size > 0) overview.textContent = `${locationNames.size} ${locationLabel}`;
      body.append(eyebrow, heading);
      if (overview.textContent) body.append(overview);
      body.append(createStorytimeList(descriptor.cards.slice(0, 3)));

      if (descriptor.cards.length > 3) {
        const remainingCount = descriptor.cards.length - 3;
        const remainingCards = descriptor.cards.slice(3);
        const disclosure = document.createElement('details');
        const summary = document.createElement('summary');
        let remainingRowsRendered = false;
        const renderRemainingRows = () => {
          if (remainingRowsRendered) return;
          disclosure.append(createStorytimeList(remainingCards));
          remainingRowsRendered = true;
        };

        disclosure.className = 'bay-storytime-day__more';
        disclosure.open = expandedStorytimeDates.has(descriptor.dateKey);
        disclosure.addEventListener('toggle', () => {
          if (disclosure.open) {
            expandedStorytimeDates.add(descriptor.dateKey);
            renderRemainingRows();
          } else {
            expandedStorytimeDates.delete(descriptor.dateKey);
          }
        });
        summary.textContent = root.dataset.storytimeMoreTemplate.replace('[count]', String(remainingCount));
        disclosure.append(summary);
        if (disclosure.open) renderRemainingRows();
        body.append(disclosure);
      }

      section.append(date, body);
      return section;
    };

    const buildDisplayItems = (matchingCards) => {
      const dateBuckets = new Map();

      matchingCards.forEach((card, index) => {
        const dateKey = card.dataset.eventDate || card.dataset.eventStart?.slice(0, 10) || `undated-${index}`;
        if (!dateBuckets.has(dateKey)) dateBuckets.set(dateKey, []);
        dateBuckets.get(dateKey).push(card);
      });

      return Array.from(dateBuckets, ([dateKey, dateCards]) => {
        const storytimeCards = dateCards.filter((card) => card.dataset.eventActivity === 'storytime-or-drop-in');
        const otherCards = dateCards.filter((card) => card.dataset.eventActivity !== 'storytime-or-drop-in');
        const displayItems = otherCards.map((card) => ({
          type: 'card',
          card,
          start: Date.parse(card.dataset.eventStart)
        }));

        if (storytimeCards.length > 1) {
          displayItems.push({
            type: 'storytime-day',
            dateKey,
            cards: storytimeCards,
            start: Date.parse(storytimeCards[0].dataset.eventStart)
          });
        } else if (storytimeCards.length === 1) {
          displayItems.push({
            type: 'card',
            card: storytimeCards[0],
            start: Date.parse(storytimeCards[0].dataset.eventStart)
          });
        }

        return displayItems.sort((first, second) => first.start - second.start);
      }).flat();
    };

    const renderAfterListFocusLeaves = () => {
      if (list.dataset.pendingRender === 'true') return;
      list.dataset.pendingRender = 'true';

      const handleFocusOut = () => {
        window.setTimeout(() => {
          if (list.contains(document.activeElement)) return;
          list.removeEventListener('focusout', handleFocusOut);
          delete list.dataset.pendingRender;
          applyFilters(false);
        }, 0);
      };

      list.addEventListener('focusout', handleFocusOut);
    };

    const synchronizePaginationLinks = () => {
      pagination?.querySelectorAll('a[href]').forEach((link) => {
        const linkUrl = new URL(link.getAttribute('href'), window.location.href);
        groups.forEach((group) => {
          const parameter = queryParameters[group];
          if (selected[group] === defaultValues[group]) linkUrl.searchParams.delete(parameter);
          else linkUrl.searchParams.set(parameter, selected[group]);
        });
        link.setAttribute('href', `${linkUrl.pathname}${linkUrl.search}${linkUrl.hash}`);
      });
    };

    const applyFilters = (updateUrl, resetLimit = false) => {
      if (resetLimit) {
        visibleLimit = selected.activity === 'storytime-or-drop-in'
          ? storytimeVisibleLimit
          : defaultVisibleLimit;
      }
      const matchingCards = cards.filter((card) => cardMatches(card, selected));
      const displayItems = buildDisplayItems(matchingCards);
      const renderedDescriptors = displayItems.slice(0, visibleLimit);
      const renderedItems = renderedDescriptors.map((descriptor) => (
        descriptor.type === 'storytime-day' ? createStorytimeGroup(descriptor) : descriptor.card
      ));
      matchingCards.forEach((card) => { card.hidden = false; });

      if (list.contains(document.activeElement)) renderAfterListFocusLeaves();
      else list.replaceChildren(...renderedItems);

      buttons.forEach((button) => {
        const group = button.dataset.eventFilterGroup;
        const value = button.dataset.eventFilterValue;
        const candidateFilters = { ...selected, [group]: value };
        const total = cards.filter((card) => cardMatches(card, candidateFilters)).length;
        const filterCount = button.querySelector('[data-filter-count]');

        button.setAttribute('aria-pressed', String(selected[group] === value));
        if (filterCount) filterCount.textContent = String(total);
      });

      const resultDateCount = new Set(matchingCards
        .map((card) => card.dataset.eventDate)
        .filter(Boolean)).size;
      const showingStorytimes = selected.activity === 'storytime-or-drop-in';
      const showingDateContext = showingStorytimes || selected.activity === 'all';
      const resultSingular = showingStorytimes ? countLabel.dataset.storytimeSingular : countLabel.dataset.singular;
      const resultPlural = showingStorytimes ? countLabel.dataset.storytimePlural : countLabel.dataset.plural;

      count.textContent = String(matchingCards.length);
      countLabel.textContent = matchingCards.length === 1 ? resultSingular : resultPlural;
      if (groupContext) {
        const resultTemplate = resultDateCount === 1
          ? root.dataset.storytimeResultSingularTemplate
          : root.dataset.storytimeResultTemplate;
        groupContext.textContent = resultTemplate.replace('[count]', String(resultDateCount));
        groupContext.hidden = !showingDateContext || resultDateCount === 0;
      }
      emptyState.hidden = matchingCards.length !== 0 || !allPagesLoaded;
      if (showMoreButton) {
        showMoreButton.textContent = showingStorytimes
          ? root.dataset.storytimeShowMoreText
          : defaultShowMoreText;
        showMoreButton.hidden = displayItems.length <= renderedItems.length;
      }
      synchronizePaginationLinks();

      if (updateUrl) {
        const url = new URL(window.location.href);

        groups.forEach((group) => {
          const parameter = queryParameters[group];
          if (selected[group] === defaultValues[group]) url.searchParams.delete(parameter);
          else url.searchParams.set(parameter, selected[group]);
        });

        if (allPagesLoaded) url.searchParams.delete(pageParam);
        window.history.replaceState({}, '', url);
      }
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        selected[button.dataset.eventFilterGroup] = button.dataset.eventFilterValue;
        applyFilters(true, true);
      });
    });

    showMoreButton?.addEventListener('click', () => {
      const previouslyRendered = list.children.length;
      visibleLimit += selected.activity === 'storytime-or-drop-in'
        ? storytimeVisibleLimit
        : defaultVisibleLimit;
      applyFilters(false);
      if (showMoreButton.hidden) {
        const firstNewCard = list.children[previouslyRendered];
        firstNewCard?.querySelector('summary, a[href], button, [tabindex]')?.focus();
      }
    });

    const hasInvalidParameter = groups.some((group) => {
      const requested = initialUrl.searchParams.get(queryParameters[group]);
      return requested && !availableValues[group].has(requested);
    });
    const hasRedundantParameter = groups.some((group) => (
      initialUrl.searchParams.get(queryParameters[group]) === defaultValues[group]
    ));
    sortCards();
    applyFilters(hasInvalidParameter || hasRedundantParameter || (allPagesLoaded && initialUrl.searchParams.has(pageParam)));

    if (pagination && allPagesLoaded) pagination.hidden = true;
    if (totalPages <= 1 || !list.dataset.eventSectionId) return;

    const pageNumbers = Array.from({ length: totalPages }, (_, index) => index + 1)
      .filter((pageNumber) => pageNumber !== currentPage);
    let nextPageIndex = 0;
    let failedPages = 0;

    list.setAttribute('aria-busy', 'true');
    if (loadingStatus) loadingStatus.hidden = false;

    const loadPage = async (pageNumber) => {
      const url = new URL(window.location.href);
      url.searchParams.set('section_id', list.dataset.eventSectionId);
      url.searchParams.set(pageParam, String(pageNumber));
      url.searchParams.delete('region');
      url.searchParams.delete('activity');
      url.searchParams.delete('schedule');
      url.searchParams.delete('host');

      const response = await fetch(url, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      if (!response.ok) throw new Error(`Event page ${pageNumber} returned ${response.status}`);

      const html = await response.text();
      const documentFragment = new DOMParser().parseFromString(html, 'text/html');
      cards.push(...upcomingCards(Array.from(documentFragment.querySelectorAll('[data-event-card]'))));
      sortCards();
      applyFilters(false);
    };

    const worker = async () => {
      while (nextPageIndex < pageNumbers.length) {
        const pageNumber = pageNumbers[nextPageIndex];
        nextPageIndex += 1;
        try {
          await loadPage(pageNumber);
        } catch (error) {
          failedPages += 1;
          console.warn(`Colorful Bunch events: unable to load event page ${pageNumber}.`, error);
        }
      }
    };

    await Promise.all(Array.from({ length: Math.min(2, pageNumbers.length) }, worker));

    allPagesLoaded = failedPages === 0;
    list.removeAttribute('aria-busy');
    if (pagination && allPagesLoaded) pagination.hidden = true;
    if (loadingStatus) {
      loadingStatus.hidden = allPagesLoaded;
      if (!allPagesLoaded && loadingStatus.dataset.errorText) {
        loadingStatus.textContent = loadingStatus.dataset.errorText;
      }
    }
    applyFilters(allPagesLoaded && initialUrl.searchParams.has(pageParam));
  };

  document.querySelectorAll('[data-bay-area-events]').forEach(initializeBayAreaEvents);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-bay-area-events]').forEach(initializeBayAreaEvents);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-native-links-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const formatterCache = new Map();

    const pad = (value) => String(value).padStart(2, '0');

    const getFormatter = (timeZone) => {
      if (!formatterCache.has(timeZone)) {
        formatterCache.set(
          timeZone,
          new Intl.DateTimeFormat('en-US', {
            timeZone,
            weekday: 'short',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hourCycle: 'h23'
          })
        );
      }
      return formatterCache.get(timeZone);
    };

    const getZonedParts = (date, timeZone) => {
      const values = {};
      getFormatter(timeZone)
        .formatToParts(date)
        .forEach((part) => {
          if (part.type !== 'literal') values[part.type] = part.value;
        });
      return {
        year: Number(values.year),
        month: Number(values.month),
        day: Number(values.day),
        dayIndex: dayNames.indexOf(values.weekday),
        hour: Number(values.hour),
        minute: Number(values.minute),
        second: Number(values.second),
        dateKey: values.year + '-' + values.month + '-' + values.day
      };
    };

    const previousCalendarDay = (parts) => {
      const value = new Date(Date.UTC(parts.year, parts.month - 1, parts.day) - 86400000);
      return {
        dateKey: value.getUTCFullYear() + '-' + pad(value.getUTCMonth() + 1) + '-' + pad(value.getUTCDate()),
        dayIndex: (parts.dayIndex + 6) % 7
      };
    };

    const parseClock = (value) => {
      const match = /^([01]\d|2[0-3]):([0-5]\d)$/.exec(value || '');
      if (!match) return null;
      return Number(match[1]) * 60 + Number(match[2]);
    };

    const formatClock = (value) => {
      const minutes = parseClock(value);
      if (minutes === null) return value || '';
      const hours = Math.floor(minutes / 60);
      const displayHours = hours % 12 || 12;
      return displayHours + ':' + pad(minutes % 60) + (hours >= 12 ? ' PM' : ' AM');
    };

    const resolveEntry = (weekly, specials, dateKey, dayIndex) => {
      const weeklyEntry = weekly[dayIndex] || { closed: true, open: '', close: '' };
      const special = specials[dateKey];
      if (!special) return weeklyEntry;
      if (special.closed) return { closed: true, open: '', close: '', special: true };
      return {
        closed: false,
        open: special.open || weeklyEntry.open,
        close: special.close || weeklyEntry.close,
        special: true
      };
    };

    const getScheduleStatus = (
      date,
      timeZone,
      weekly,
      specials,
      closesSoonMinutes = 30,
      statusMode = 'automatic'
    ) => {
      if (statusMode === 'open') return { isOpen: true, closesSoon: false, minutesToClose: null };
      if (statusMode === 'closed') return { isOpen: false, closesSoon: false, minutesToClose: null };

      const parts = getZonedParts(date, timeZone);
      const nowMinutes = parts.hour * 60 + parts.minute + parts.second / 60;
      const today = resolveEntry(weekly, specials, parts.dateKey, parts.dayIndex);
      const previous = previousCalendarDay(parts);
      const yesterday = resolveEntry(weekly, specials, previous.dateKey, previous.dayIndex);

      const evaluateToday = (entry) => {
        if (!entry || entry.closed) return null;
        const open = parseClock(entry.open);
        const close = parseClock(entry.close);
        if (open === null || close === null) return null;
        if (close <= open && nowMinutes >= open) return 1440 - nowMinutes + close;
        if (close > open && nowMinutes >= open && nowMinutes <= close) return close - nowMinutes;
        return null;
      };

      const evaluateYesterday = (entry) => {
        if (!entry || entry.closed) return null;
        const open = parseClock(entry.open);
        const close = parseClock(entry.close);
        if (open === null || close === null || close > open) return null;
        if (nowMinutes <= close) return close - nowMinutes;
        return null;
      };

      const minutesToClose = evaluateToday(today) ?? evaluateYesterday(yesterday);
      if (minutesToClose === null) {
        return { isOpen: false, closesSoon: false, minutesToClose: null, parts };
      }
      return {
        isOpen: true,
        closesSoon: minutesToClose <= Number(closesSoonMinutes),
        minutesToClose,
        parts
      };
    };

    const isUpdateVisible = (date, startAt, endAt) => {
      const start = startAt ? new Date(startAt) : null;
      const end = endAt ? new Date(endAt) : null;
      if (start && !Number.isNaN(start.getTime()) && date < start) return false;
      if (end && !Number.isNaN(end.getTime()) && date > end) return false;
      return true;
    };

    const chooseDirectionsUrl = (userAgent, appleUrl, googleUrl) => {
      const preferApple = /iPhone|iPad|iPod/i.test(userAgent || '');
      if (preferApple) return appleUrl || googleUrl || '';
      return googleUrl || appleUrl || '';
    };

    const readSchedule = (section) => {
      const weekly = {};
      section.querySelectorAll('[data-native-links-hours-row]').forEach((row) => {
        weekly[Number(row.dataset.dayIndex)] = {
          closed: row.dataset.closed === 'true',
          open: row.dataset.open || '',
          close: row.dataset.close || ''
        };
      });
      const specials = {};
      section.querySelectorAll('[data-native-links-special-hour]').forEach((item) => {
        if (!item.dataset.date) return;
        specials[item.dataset.date] = {
          closed: item.dataset.closed === 'true',
          open: item.dataset.open || '',
          close: item.dataset.close || '',
          note: item.dataset.note || ''
        };
      });
      return { weekly, specials };
    };

    const updateHours = (section, now, timeZone, weekly, specials) => {
      let parts;
      try {
        parts = getZonedParts(now, timeZone);
      } catch (error) {
        parts = getZonedParts(now, 'UTC');
      }
      section.querySelectorAll('[data-native-links-hours-row]').forEach((row) => {
        const isToday = Number(row.dataset.dayIndex) === parts.dayIndex;
        row.classList.toggle('today', isToday);
        if (!isToday) return;
        const entry = resolveEntry(weekly, specials, parts.dateKey, parts.dayIndex);
        const time = row.querySelector('[data-native-links-hours-time]');
        if (!time) return;
        if (entry.closed || !entry.open || !entry.close) {
          time.textContent =
            section.dataset.closedText.charAt(0) +
            section.dataset.closedText.slice(1).toLowerCase() +
            (entry.special ? ' (Special)' : '');
        } else {
          time.textContent = formatClock(entry.open) + ' - ' + formatClock(entry.close) + (entry.special ? ' (Special)' : '');
        }
      });
    };

    const updateStatus = (section, now, timeZone, weekly, specials) => {
      const status = section.querySelector('[data-native-links-status]');
      if (!status) return;
      let state;
      try {
        state = getScheduleStatus(
          now,
          timeZone,
          weekly,
          specials,
          Number(section.dataset.closesSoonMinutes || 30),
          section.dataset.statusMode || 'automatic'
        );
      } catch (error) {
        state = { isOpen: false, closesSoon: false };
      }
      const dot = section.querySelector('[data-native-links-status-dot]');
      const text = section.querySelector('[data-native-links-status-text]');
      const className = state.closesSoon ? 'closes-soon' : state.isOpen ? 'open' : 'closed';
      dot.classList.remove('open', 'closed', 'closes-soon');
      dot.classList.add(className);
      text.textContent = state.closesSoon
        ? section.dataset.closesSoonText
        : state.isOpen
          ? section.dataset.openText
          : section.dataset.closedText;
    };

    const updateScheduledItems = (section, now) => {
      const items = Array.from(section.querySelectorAll('[data-native-links-update]'));
      let visibleCount = 0;
      items.forEach((item) => {
        const visible = isUpdateVisible(now, item.dataset.startAt, item.dataset.endAt);
        item.hidden = !visible;
        if (visible) visibleCount += 1;
      });
      const updates = section.querySelector('[data-native-links-updates]');
      if (updates) updates.hidden = visibleCount === 0;
    };

    const updateDirections = (section) => {
      const link = section.querySelector('[data-native-links-directions]');
      if (!link) return;
      const url = chooseDirectionsUrl(
        window.navigator && window.navigator.userAgent,
        section.dataset.appleDirectionsUrl,
        section.dataset.googleDirectionsUrl
      );
      if (url) link.href = url;
    };

    const updateSection = (section, now = new Date()) => {
      const timeZone = section.dataset.timezone || 'America/Los_Angeles';
      const { weekly, specials } = readSchedule(section);
      updateHours(section, now, timeZone, weekly, specials);
      updateStatus(section, now, timeZone, weekly, specials);
      updateScheduledItems(section, now);
      updateDirections(section);
    };

    const updateAll = () => {
      document.querySelectorAll('[data-native-links-section]').forEach((section) => updateSection(section));
    };

    window.ColorfulBunchNativeLinks = Object.freeze({
      chooseDirectionsUrl,
      formatClock,
      getScheduleStatus,
      getZonedParts,
      isUpdateVisible,
      parseClock,
      updateSection
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updateAll, { once: true });
    } else {
      updateAll();
    }
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('[data-native-links-section]');
      if (section) updateSection(section);
    });
    window.setInterval(updateAll, 60000);
  })();

  } catch(e) { console.error(e); }
})();
})();
